import "./Filter.css";
import { useDispatch, useSelector } from "react-redux";
import {
   setTitleFilter,
   selectTitleFilter,
   setAuthorFilter,
   selectAuthorFilter,
   resetFilters,
   setIsFavoritFilter,
   selectIsFavoritFilter,
} from "../../redux/slices/filterSlice";

const Filter = () => {
   const dispatch = useDispatch();
   const titleFilter = useSelector(selectTitleFilter);
   const authorFilter = useSelector(selectAuthorFilter);
   const isFavoritFilter = useSelector(selectIsFavoritFilter);

   const titleFilterChageHendler = (e) => {
      dispatch(setTitleFilter(e.target.value));
   };

   const authorFilterChageHendler = (e) => {
      dispatch(setAuthorFilter(e.target.value));
   };

   const isFavoritFilterChageHendler = () => {
      dispatch(setIsFavoritFilter());
   };

   const resetFiltersHenler = () => {
      dispatch(resetFilters());
   };
   return (
      <div className="app-block filter">
         <div className="filter-row">
            <div className="filter-group">
               <input
                  onChange={titleFilterChageHendler}
                  type="text"
                  value={titleFilter}
                  placeholder="Filter by title ..."
               />
            </div>
            <div className="filter-group">
               <input
                  onChange={authorFilterChageHendler}
                  type="text"
                  value={authorFilter}
                  placeholder="Filter by author ..."
               />
            </div>
            <div className="filter-group">
               <label htmlFor="isFavorit">
                  <input
                     onChange={isFavoritFilterChageHendler}
                     type="checkbox"
                     id="isFavorit"
                     checked={isFavoritFilter}
                     placeholder="Filter by author ..."
                  />
                  Only favorit
               </label>
            </div>
            <button type="button" onClick={resetFiltersHenler}>
               Reset filters
            </button>
         </div>
      </div>
   );
};

export default Filter;
